const RestrictionType = {
    None: 0,
    FullBlock: 1,
    Login: 2,
    Registration: 3,
    LoginAndRegistration: 4
}

export default RestrictionType;
